import { useApiMutation, useApiQuery } from './base';
import {
  CreateCheckOutRequest,
  BillingCheckOutResponse,
  SubscriptionData,
  ManageSubscriptionResponse,
  PriceInfo,
} from '../types';

export const useGetPricing = () => {
  return useApiQuery<PriceInfo[]>(['fetchPricing'], '/billing/prices');
};

export const useBillingCheckOutSession = () => {
  return useApiMutation<BillingCheckOutResponse, CreateCheckOutRequest>(
    '/billing/create-checkout-session',
    'POST',
  );
};

export const useSubscriptionStatus = (enabled: boolean) => {
  return useApiQuery<SubscriptionData>(
    ['getSubscriptionStatus'],
    '/billing/subscription-status',
    { enabled },
  );
};

export const useManageSubscription = () => {
  return useApiMutation<ManageSubscriptionResponse, void>(
    '/billing/create-portal-session',
    'POST',
  );
};
